import React from 'react';
import { FeedbackPage } from '@front-activerse/modules';
import { Route } from '../Routing/types';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/feedback',
    element: <FeedbackPage />,
    private: true,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
];

export default routes;
